module.exports = __webpack_public_path__ + "static/media/voice.97948ca7.gif";